import { useContext, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ChatContext, ChatContextInterface } from "./MSRContext";
import LoadingPage from "./LoadingPage";

/**
 * Routes that establish a session themselves and must not be bounced to the
 * login form while they are still working. /sso in particular may be waiting on
 * a token from the host page, which arrives asynchronously.
 */
const SELF_AUTHENTICATING_ROUTES = ["/login", "/sso"];

export default function AuthGuide() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { loading } = useContext(ChatContext) as ChatContextInterface;
  const isAuthenticated = Boolean (localStorage.getItem("isAuthenticated"));
  const wrapper = Boolean (localStorage.getItem("wrapper"));

  console.log("In auth", loading, isAuthenticated, wrapper);

  useEffect(() => {
    if (loading) return;
    if (SELF_AUTHENTICATING_ROUTES.includes(pathname)) return;

    if (!wrapper && !isAuthenticated) {
      console.log("should navigate to login page");
      navigate("/login");
    } else if (wrapper && isAuthenticated) {
      console.log("should navigate to home page");
      const lastVisitedRoute = sessionStorage.getItem("lastVisitedRoute");
      if (lastVisitedRoute && lastVisitedRoute !== window.location.pathname) {
        navigate(lastVisitedRoute); // Navigate back to the last visited route
      }
    }
  }, [isAuthenticated, loading, wrapper, navigate, pathname]);

  if (loading) {
    console.log("loading...");
    return <LoadingPage />;
  }

  return <Outlet />;
}
